import { useT } from "../../../core/i18n";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import { getMyProfile } from "../../../core/data/redux/employeesSlice";
import { all_routes } from "../../router/all_routes";

function LeavManagment() {
  const { t } = useT();
  const routes = all_routes;

  const dispatch = useDispatch();
  const employeesState = useSelector((state: any) => state.employeesState);

  const [officeList, setOfficeList] = useState<any[]>([]);
  const [filteredList, setFilteredList] = useState<any[]>([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 10,
  });

  const hasFetchedProfile = useRef(false);

  useEffect(() => {
    if (!hasFetchedProfile.current) {
      dispatch(getMyProfile({}));
      hasFetchedProfile.current = true;
    }
  }, []);

  useEffect(() => {
    const offices = employeesState?.data?.data?.offices || [];
    console.log(offices);
    setOfficeList(offices);
    setFilteredList(offices);
    setPagination((prev) => ({
      ...prev,
      total: offices.length,
    }));
  }, []);

  const handleSearch = (value: string) => {
    const keyword = value.toLowerCase();
    const filtered = officeList.filter((item) =>
      item.name.toLowerCase().includes(keyword)
    );
    setFilteredList(filtered);
    setPagination((prev) => ({
      ...prev,
      total: filtered.length,
      current: 1,
    }));
  };

  const handlePagination = (pageInfo: any) => {
    setPagination((prev) => ({
      ...prev,
      current: pageInfo.current,
      pageSize: pageInfo.pageSize,
    }));
  };

  const officeColumns = [
    {
      title: t("sr_no"),
      dataIndex: "id",
      width: 80,
      render: (text: string, record: any, index: number) =>
        index + 1 + (pagination.current - 1) * pagination.pageSize,
    },
    {
      title: t("office_name"),
      dataIndex: "name",
    },
    {
      title: t("latitude"),
      dataIndex: "lat",
    },
    {
      title: t("longitude"),
      dataIndex: "long",
    },
    {
      title: t("status"),
      dataIndex: "status",
      render: (status: boolean) => (
        <span
          style={{
            padding: "4px 8px",
            borderRadius: "4px",
            backgroundColor: status ? "#049123" : "#C0282C",
            color: "white",
            fontSize: "12px",
          }}
        >
          {status ? "Active" : "Inactive"}
        </span>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">{t("assigned_location")}</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.adminDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="#">Employees</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">{t("assigned_location")}</li>
              </ol>
            </nav>
          </div>
        </div>

        <div className="card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
            <h4 className="mb-4 mt-3">{t("my_assigned_office_location")}</h4>
          </div>
          <div className="card-body">
            <Table
              columns={officeColumns}
              dataSource={filteredList}
              Selection={false}
              paginationConfig={pagination}
              handlePagination={handlePagination}
              loading={employeesState.loading === "pending"}
              handleSearch={handleSearch}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default LeavManagment;
